module.exports = __webpack_public_path__ + "img/old4.7c172a9f.jpg";